<!-- Navigation -->
<nav class="navbar navbar-default fixed-top  w-100" style="background-color: #2b2b2b !important">
  <my-navigation></my-navigation>
</nav>


<div class="contact-cta">
  <div class="inner-wrapper">
    <h3>Contact</h3>
    <p>Natalie Costello: <a href="tel:6479661326">647.966.1326</a></p>
  </div>
</div>


<!-- form Section -->
<section id="form" class="forms search-results-page-filters clearfix">
  <my-peelhalton-listing-search (filterListings)="filterListings($event)"></my-peelhalton-listing-search>
  <div class="search-results-totals">
        <span *ngIf="listings">
            <h3>Showing {{ listings.length }} of {{ this.globals.countNum }} properties</h3>
        </span>
  </div>
  <main id="searchResults" class="clearfix"
        infiniteScroll
        [infiniteScrollDistance]="50"
        [infiniteScrollUpDistance]="1"
        [infiniteScrollThrottle]="0"
        (scrolled)="onScrollDownGlobal()"
        (scrolledUp)="onScrollUpGlobal()"
        [scrollWindow]="true"
        [alwaysCallback]="true"
  >
    <div id="resultsList"
         infiniteScroll
         [infiniteScrollDistance]="7"
         [infiniteScrollUpDistance]="1"
         [infiniteScrollThrottle]="50"
         (scrolled)="onScrollDown()"
         (scrolledUp)="onScrollUp()"
         [scrollWindow]="false">
      <!-- SSR fallback: when currentScreenSize is not yet determined on the server, render a default list -->
      <ng-container *ngIf="!currentScreenSize">
        <app-property-card *ngFor="let listing of listings"
                           [listing]="listing"
                           (cardClick)="gotoDetailDirect(listing)">
        </app-property-card>
      </ng-container>
      <span *ngIf="currentScreenSize==='XSmall'">
            <div *ngFor="let listing of listings" (click)="gotoDetailDirect(listing)">
                <div class="property active" style="cursor: pointer; ">
                        <div class="featured-image"
                             [ngStyle]="{ 'background-image': 'url(' + listing.listingMedia.data[0].url + ')', 'cursor': 'pointer' }">
                            <div *ngIf="((listing.listingStatus | lowercase)==='sold' && !listing.exclusive)" class="banner sold">
                                <div class="line">
                                    <span>Sold</span>
                                </div>
                            </div>
                            <div *ngIf="listing.exclusive" class="banner exclusive">
                                <div class="line">
                                    <span>Exclusive</span>
                                </div>
                            </div>
                            <div *ngIf="listing.isModified && !listing.isNew && !listing.isPriceChange" class="banner change">
                                <div class="line">
                                    <span>Modified</span>
                                </div>
                            </div>
                            <div *ngIf="listing.isModified && !listing.isNew && listing.isPriceChange" class="banner change">
                                <div class="line">
                                    <span>Price change</span>
                                </div>
                            </div>
                            <div *ngIf="listing.isNew" class="banner new">
                                <div class="line">
                                    <span>New</span>
                                </div>
                            </div>
                        </div>
                    <div class="content">
                            <div class="row">
                                <div id="propertyPrice" class="price">{{ listing.listingPrice | currency : '' : 'symbol' : '1.0-0' }}  <span *ngIf="(listing.listingStatus | lowercase)==='rental'">/ Week</span></div>
                            </div>
                            <div class="row">
                                <p id="propertyDescription" class="description"><span class="sold"
                                                                                      *ngIf="((listing.listingStatus | lowercase)==='sold' && !listing.exclusive)">{{ listing.listingStatus }}</span><span
                                  class="exclusive" *ngIf="listing.exclusive">Exclusive</span>{{ listing.community }}
                                </p>
                            </div>


                            <div *ngIf="(listing.listingStatus | lowercase)!=='rental' && listing.bedroomsTotal" class="row">
                                <p id="propertyFeet" class="feet">{{ listing.bedroomsTotal }} Bedrooms</p>
                            </div>
                            <div *ngIf="(listing.listingStatus | lowercase)==='rental' && listing.bathroomsTotal" class="row">
                                <p id="propertyFeet" class="feet">{{ listing.bathroomsTotal }} Bathrooms</p>
                            </div>
                            <div class="row">
                                <ul class="links">
                                    <li *ngIf="listing.virtualTourUrl"><a id="virtualTour" href="{{listing.virtualTourUrl}}" target="_blank">Virtual Tour</a></li>
                                    <li *ngIf="listing.brochureLink"><a id="brochure" href="{{listing.brochureLink}}" target="_blank">Brochure</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
            </div>
        </span>
      <span *ngIf="currentScreenSize==='Small' || currentScreenSize==='Medium'">
            <div *ngFor="let listing of listings" (click)="gotoDetailDirect(listing)">
                <div class="property active" style="cursor: pointer; ">
                        <div class="featured-image"
                             [ngStyle]="{ 'background-image': 'url(' + listing.listingMedia.data[0].url + ')'}">
                            <div *ngIf="((listing.listingStatus | lowercase)==='sold' && !listing.exclusive)" class="banner sold">
                                <div class="line">
                                    <span>Sold</span>
                                </div>
                            </div>
                            <div *ngIf="listing.exclusive" class="banner exclusive">
                                <div class="line">
                                    <span>Exclusive</span>
                                </div>
                            </div>
                            <div *ngIf="listing.isModified && !listing.isNew && !listing.isPriceChange" class="banner change">
                                <div class="line">
                                    <span>Modified</span>
                                </div>
                            </div>
                            <div *ngIf="listing.isModified && !listing.isNew && listing.isPriceChange" class="banner change">
                                <div class="line">
                                    <span>Price change</span>
                                </div>
                            </div>
                            <div *ngIf="listing.isNew" class="banner new">
                                <div class="line">
                                    <span>New</span>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            <div class="row">
                                <div id="propertyPrice" class="price">{{ listing.listingPrice | currency : '' : 'symbol' : '1.0-0' }}  <span *ngIf="(listing.listingStatus | lowercase)==='rental'">/ Week</span></div>
                            </div>
                            <div class="row">
                                <p id="propertyLocation" class="location">{{ listing.community }}</p>
                            </div>
                            <div class="row">
                                <p id="propertyDescription" class="description"><span class="sold"
                                                                                      *ngIf="((listing.listingStatus | lowercase)==='sold' && !listing.exclusive)">{{ listing.listingStatus }}</span><span
                                  class="exclusive" *ngIf="listing.exclusive">Exclusive</span>{{ listing.community }}
                                </p>
                            </div>
                            <div *ngIf="(listing.listingStatus | lowercase)!=='rental' && listing.bedroomsTotal" class="row">
                                <p id="propertyFeet" class="feet">{{ listing.bedroomsTotal }} Bedrooms</p>
                            </div>
                            <div *ngIf="(listing.listingStatus | lowercase)==='rental' && listing.bathroomsTotal" class="row">
                                <p id="propertyFeet" class="feet">{{ listing.bathroomsTotal }} Bathrooms</p>
                            </div>
                            <div class="row">
                                <ul class="links">
                                    <li *ngIf="listing.virtualTourUrl"><a id="virtualTour" href="{{listing.virtualTourUrl}}" target="_blank">Virtual Tour</a></li>
                                    <li *ngIf="listing.brochureLink"><a id="brochure" href="{{listing.brochureLink}}" target="_blank">Brochure</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
            </div>
        </span>
      <span *ngIf="currentScreenSize==='Large' || currentScreenSize==='XLarge'">
            <div *ngFor="let listing of listings" (click)="gotoDetail(listing)">
                <div class="property active">
                  <div class="featured-image"
                       [ngStyle]="{ 'background-image': 'url(' + listing.listingMedia.data[0].url + ')', 'cursor': 'pointer'}">
                            <div *ngIf="((listing.listingStatus | lowercase)==='sold' && !listing.exclusive)" class="banner sold">
                                <div class="line">
                                    <span>Sold</span>
                                </div>
                            </div>
                            <div *ngIf="listing.exclusive" class="banner exclusive">
                                <div class="line">
                                    <span>Exclusive</span>
                                </div>
                            </div>
                            <div *ngIf="listing.isModified && !listing.isNew && !listing.isPriceChange" class="banner change">
                                <div class="line">
                                    <span>Modified</span>
                                </div>
                            </div>
                            <div *ngIf="listing.isModified && !listing.isNew && listing.isPriceChange" class="banner change">
                                <div class="line">
                                    <span>Price change</span>
                                </div>
                            </div>
                            <div *ngIf="listing.isNew" class="banner new">
                                <div class="line">
                                    <span>New</span>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            <div class="row">
                                <div id="propertyPrice" class="price">{{ listing.listingPrice | currency : '' : 'symbol' : '1.0-0' }} <span
                                  *ngIf="(listing.listingStatus | lowercase)==='rental'">/ Week</span></div>
                            </div>
                            <div class="row">
                                <p id="propertyDescription" class="description"><span class="sold"
                                                                                      *ngIf="((listing.listingStatus | lowercase)==='sold' && !listing.exclusive)">{{ listing.listingStatus }}</span><span
                                  class="exclusive" *ngIf="listing.exclusive">Exclusive</span>{{ listing.community }}
                                </p>
                            </div>
                            <div *ngIf="(listing.listingStatus | lowercase)!=='rental' && listing.bedroomsTotal" class="row">
                                <p id="propertyFeet" class="feet">{{ listing.bedroomsTotal }} Bedrooms</p>
                            </div>
                            <div *ngIf="(listing.listingStatus | lowercase)==='rental' && listing.bathroomsTotal" class="row">
                                <p id="propertyFeet" class="feet">{{ listing.bathroomsTotal }} Bathrooms</p>
                            </div>
                            <div class="row">
                                <ul class="links">
                                    <li *ngIf="listing.virtualTourUrl"><a id="virtualTour" href="{{listing.virtualTourUrl}}" target="_blank">Virtual Tour</a></li>
                                    <li *ngIf="listing.brochureLink"><a id="brochure" href="{{listing.brochureLink}}" target="_blank">Brochure</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
            </div>
        </span>
      <div class="end-of-list" *ngIf="listings.length < this.globals.countNum">
        <p>Your results are loading.</p>
      </div>
    </div>
    <div id="selectedProperty" *ngIf="isSelectedBln === true && selectedListing!==undefined"
         infiniteScroll
         [scrollWindow]="false">
      <div class="active-property">
        <div class="gallery">
          <app-ngbd-carousel-config [imageArr]="selectedListing.listingMedia.data" [addressHyphenStr]="(selectedListing.listingDetail?.address ?? selectedListing.fullAddress).replaceAll(' ', '-')"
                                    [cityHyphenStr]="selectedListing.municipality.replaceAll(' ', '-')" [MLSNum]="selectedListing.MLSNUM"></app-ngbd-carousel-config>

        </div>
        <div class="content">
          <div id="propertyPrice" class="price">{{ selectedListing.listingPrice | currency : '' : 'symbol' : '1.0-0' }} <span
            *ngIf="(selectedListing.listingStatus | lowercase)==='rental'">/ Week</span>
          </div>
          <div class="row">
            <p id="propertyLocation" class="location">{{ selectedListing.community }}</p>
          </div>
          <div class="row">
            <p id="propertyDescription" class="description"><span *ngIf="selectedListing.sourceStr==='TREB'">{{ selectedListing.fullAddress }}</span><span
              *ngIf="selectedListing.sourceStr==='TREB'">{{ selectedListing.community }}</span></p>
          </div>
          <div *ngIf="(selectedListing.listingStatus | lowercase)!=='rental' && selectedListing.squareFootage" class="row">
            <p id="propertyFeet" class="feet">{{ selectedListing.squareFootage }} sq. FT.</p>
          </div>
          <div *ngIf="(selectedListing.listingStatus | lowercase)==='rental' && selectedListing.bedroomsTotal" class="row">
            <p id="propertyFeet" class="feet">{{ selectedListing.bedroomsTotal }} Bedrooms</p>
          </div>
          <div *ngIf="(selectedListing.listingStatus | lowercase)==='rental' && selectedListing.bathroomsTotal" class="row">
            <p id="propertyFeet" class="feet">{{ selectedListing.bathroomsTotal }} Bathrooms</p>
          </div>
          <div class="row">
            <ul class="links">
              <li *ngIf="selectedListing.virtualTourUrl"><a id="virtualTour" href="{{selectedListing.virtualTourUrl}}" target="_blank">Virtual Tour</a></li>
              <li *ngIf="selectedListing.brochureLink"><a id="brochure" href="{{selectedListing.brochureLink}}" target="_blank">Brochure</a></li>
            </ul>
          </div>
          <div class="row">
            <!--<a id="viewFullDetails" class="full-details-link" href="http://m2.caymanmarshall.com/fulldetails/{{selectedListing.MLSNUM}}" target="_blank">View full details</a>-->
            <a id="viewFullDetails" class="full-details-link"
               [routerLink]="'fulldetails/' + (selectedListing.listingDetail?.address ?? selectedListing.fullAddress).replaceAll(' ', '-') + '/' + selectedListing.municipality.replaceAll(' ', '-') + '/' + selectedListing.MLSNUM">View
              Full
              Details</a>
          </div>
          <div class="row">
            <h3 class="description-heading">Description</h3>
          </div>
          <div class="row">
            <p class="description">{{ selectedListing.description | slice:0:90 }}...</p>
          </div>
          <br>
          <br>
          <div class="row">
            <p id="propertyFeet" class="feet">Listing courtesy of  {{ selectedListing.listingBrokerage }}</p>
          </div>
          <div class="row">
            <ul class="features">
              <li *ngIf="selectedListing.squareFootage" id="feet">{{ selectedListing.squareFootage }} Sq. Ft.</li>
              <li *ngIf="selectedListing.lotSize" id="acres">{{ selectedListing.lotSize }}</li>
              <li *ngIf="selectedListing.bedroomsTotal>0" id="bedrooms">{{ selectedListing.bedroomsTotal }} Bedrooms</li>
              <li *ngIf="selectedListing.bathroomsTotal>0" id="bathrooms">{{ selectedListing.bathroomsTotal }}
                Bathrooms
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</section>
